.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 40px 24px;
  text-align: center;
}

.compact {
  padding: 24px 16px;
  gap: 6px;
}

.iconWrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--c-brand-subtle);
  color: var(--c-brand-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.compact .iconWrap {
  width: 36px;
  height: 36px;
  border-radius: 10px;
}

.neg {
  background: var(--c-negative-subtle);
  color: var(--c-negative);
}

.title {
  font-size: var(--text-callout);
  font-weight: 600;
}

.body {
  max-width: 440px;
  font-size: var(--text-caption);
  color: var(--c-text-secondary);
  line-height: 1.5;
}

.requestId {
  font-family: var(--font-mono);
  font-size: var(--text-micro);
  color: var(--c-text-tertiary);
}

.skeleton {
  display: inline-block;
  background: linear-gradient(
    90deg,
    var(--c-surface-elevated) 0%,
    color-mix(in srgb, var(--c-border) 70%, var(--c-surface-elevated)) 50%,
    var(--c-surface-elevated) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.4s ease-in-out infinite;
}

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.rows {
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 0 16px;
  border-top: 1px solid var(--c-border);
}

.chart {
  padding: 12px 16px;
}

.spinner {
  display: inline-block;
  border-radius: 50%;
  border: 2px solid var(--c-border-strong);
  border-top-color: var(--c-brand);
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loadingArea {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 60px;
  color: var(--c-text-tertiary);
  font-size: var(--text-caption);
}
